export var InterestRateType;
(function (InterestRateType) {
    InterestRateType["Variable"] = "VARIABLE";
    InterestRateType["Fixed"] = "FIXED";
    InterestRateType["Both"] = "BOTH";
})(InterestRateType || (InterestRateType = {}));
//# sourceMappingURL=InterestRateType.js.map